import React from "react"
import { Chip, IconButton, FontIcon } from "material-ui"
import strings from "../../../localization/strings"
import autobind from "class-autobind"
import { IBudgetUnitItem, IUnitItem } from "../../../models"
import AddScheduleBudgetUnitPositionDefinitionDialog from "./AddScheduleBudgetUnitPositionDefinitionDialog"
import _ from "lodash"
interface IProps {
    readonly: boolean
    budgetUnits: IUnitItem[]
    budgetUnitPositionDefinitions: IBudgetUnitItem[]
    handleUpdate(budgetUnitPositionDefinitions: IBudgetUnitItem[]): void
}

interface IState {
    openAddBudgetUnitPositionDefinitionDialog: boolean
}

export default class ScheduleBudgetUnitPositionDefinitions extends React.Component<IProps, IState>  {
    constructor(props: IProps) {
        super(props)
        this.state = {
            openAddBudgetUnitPositionDefinitionDialog: false
        }
        autobind(this)
    }

    render() {
        return (
            <div style={{ minHeight: 75 }}>
                <div style={{ fontSize: 14, fontWeight: "bold" }}>
                    {strings.Budget_Unit_Position_Definitions}
                </div>
                <div style={{ display: "flex", flexWrap: "wrap" }}>
                    {this.props.budgetUnitPositionDefinitions.length > 0 ?
                        this.props.budgetUnitPositionDefinitions.map((unit, index) =>
                            <Chip
                                key={index}
                                style={{ margin: 2, height: 35, width: "min-content" }}
                                onRequestDelete={this.props.readonly ?
                                    null :
                                    () => {
                                        const budgetUnitPositionDefinitions = _.cloneDeep(this.props.budgetUnitPositionDefinitions)
                                        budgetUnitPositionDefinitions.splice(budgetUnitPositionDefinitions.indexOf(unit), 1)
                                        this.props.handleUpdate(budgetUnitPositionDefinitions)
                                    }}
                            >
                                {unit.UnitName} to {unit.PositionName}: {unit.PerUnitFactor}
                            </Chip>
                        ) :
                        this.props.readonly &&
                        <div style={{ marginTop: 5, marginLeft: 10 }}>{strings.There_is_no_Budget_Unit_Position_Definition_item}</div>
                    }
                    {!this.props.readonly &&
                        <IconButton
                            style={{ height: 35, width: 35, padding: 0, margin: 0, display: "inline-block" }}
                            onTouchTap={() => { this.setState({ openAddBudgetUnitPositionDefinitionDialog: true }) }}
                        >
                            <FontIcon className="fa fa-plus-circle" />
                        </IconButton>
                    }
                </div>
                {this.state.openAddBudgetUnitPositionDefinitionDialog &&
                    <AddScheduleBudgetUnitPositionDefinitionDialog
                        budgetUnits={this.props.budgetUnits}
                        handleAdd={budgetUnitPositionDefinition => {
                            const budgetUnitPositionDefinitions = _.cloneDeep(this.props.budgetUnitPositionDefinitions)
                            budgetUnitPositionDefinitions.push(budgetUnitPositionDefinition)
                            this.setState({ openAddBudgetUnitPositionDefinitionDialog: false }, () =>
                                this.props.handleUpdate(budgetUnitPositionDefinitions)
                            )
                        }}
                        handleClose={() => this.setState({ openAddBudgetUnitPositionDefinitionDialog: false })}
                    />
                }
            </div>
        )
    }
}